"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import HeaderWithMenu from "../HeaderWithMenu";
import { default as Content } from './Content';
import { default as Footer } from './Footer';
import AppSettings from "../../lib/AppSettings";
import { WidgetFrame } from "./WidgetFrame";
import { useSettingsState } from "../../exports";
const Widget = ({ children, hideMenu, goBack, contextualMenu, fitHeight = false }) => {
    const { isEmbedded } = useSettingsState();
    return _jsx(WidgetFrame, { enableWideVersion: AppSettings.ThemeData?.enableWideVersion, isEmbedded: isEmbedded, fitHeight: fitHeight, backgroundStyle: AppSettings.ThemeData?.cardBackgroundStyle, testnet: AppSettings.ApiVersion === 'testnet', header: !hideMenu && _jsx(HeaderWithMenu, { goBack: goBack, contextualMenu: contextualMenu }), children: children });
};
Widget.Content = Content;
Widget.Footer = Footer;
export { Widget };
